import { BookDetailsModel, BookDetailsResp } from '../types/book-details'

export const transformBookDetails = ({ book_details }: BookDetailsResp): BookDetailsModel => ({
  author: book_details.author,
  title: book_details.title,
})
